import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useRef } from "react";
import noimg from "../../../../assets/images/noimg.webp";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import FacebookIcon from "@mui/icons-material/Facebook";
import InsertLinkIcon from "@mui/icons-material/InsertLink";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";

export default function UserDetailModal({ open, setOpen, userDetail }) {
  const cancelButtonRef = useRef(null);
  const occupation = userDetail.Occupation;

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-6xl">
                <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                  <div>
                    <h1 className="text-md font-semibold text-blue-400">
                      PERSONAL INFO
                    </h1>
                    <div className="mt-5 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-12">
                      <div className="sm:col-span-3">
                        <img
                          class="w-10 h-10 p-1 rounded-full ring-2 ring-gray-300 dark:ring-gray-500"
                          src={userDetail?.ProfilePicture || noimg}
                          alt="Bordered avatar"
                        />
                      </div>
                      <div className="sm:col-span-3">
                        <div className="min-w-0 flex-auto">
                          <p className="text-sm font-semibold leading-6 text-gray-900">
                            Email
                          </p>
                          <p className="mt-1 truncate text-sm leading-5 text-gray-500">
                            {userDetail.Email || "NA"}
                          </p>
                        </div>
                      </div>

                      <div className="sm:col-span-3">
                        <p className="text-sm font-semibold leading-6 text-gray-900">
                          Name
                        </p>
                        <p className="mt-1 truncate text-sm leading-5 text-gray-500">
                          {userDetail?.Name || "NA"}
                        </p>
                      </div>
                      <div className="sm:col-span-3">
                        <p className="text-sm font-semibold leading-6 text-gray-900">
                          Occupation
                        </p>
                        <p className="mt-1 truncate text-sm leading-5 text-gray-500">
                          {userDetail?.Occupation || "NA"}
                        </p>
                      </div>

                      <div className="sm:col-span-3">
                        <div className="min-w-0 flex-auto">
                          <p className="text-sm font-semibold leading-6 text-gray-900">
                            Country
                          </p>
                          <p className="mt-1 truncate text-sm leading-5 text-gray-500">
                            {userDetail?.Country?.countryName || "NA"}
                          </p>
                        </div>
                      </div>

                      <div className="sm:col-span-6">
                        <div className="min-w-0 flex-auto">
                          <p className="text-sm font-semibold leading-6 text-gray-900">
                            Biography
                          </p>
                          <p className="mt-1 truncate text-sm leading-5 text-gray-500">
                            {userDetail?.ShortBio || "NA"}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="mt-5">
                      <h1 className="text-md font-semibold text-blue-400">
                        PROFESSIONAL INFO
                      </h1>

                      <div className="mt-5 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-12">
                        {occupation !== "Product" && (
                          <div className="sm:col-span-3">
                            <div className="min-w-0 flex-auto">
                              <p className="text-sm font-semibold leading-6 text-gray-900">
                                Professional Position
                              </p>
                              <p className="mt-1 truncate text-sm leading-5 text-gray-500">
                                {userDetail?.ProfessionPositionName || "NA"}
                              </p>
                            </div>
                          </div>
                        )}
                        <div className="sm:col-span-3">
                          <div className="min-w-0 flex-auto">
                            <p className="text-sm font-semibold leading-6 text-gray-900">
                              Start Year in the Industry
                            </p>
                            <p className="mt-1 truncate text-sm leading-5 text-gray-500">
                              {userDetail?.StartYear || "NA"}
                            </p>
                          </div>
                        </div>
                        {occupation === "Product" && (
                          <div className="sm:col-span-3">
                            <div className="min-w-0 flex-auto">
                              <p className="text-sm font-semibold leading-6 text-gray-900">
                                Operations
                              </p>
                              <p className="mt-1 truncate text-sm leading-5 text-gray-500">
                                {userDetail?.OperationRange || "NA"}
                              </p>
                            </div>
                          </div>
                        )}
                        <div className="sm:col-span-3">
                          <div className="min-w-0 flex-auto">
                            <p className="text-sm font-semibold leading-6 text-gray-900">
                              Industry
                            </p>
                            <p className="mt-1 truncate text-sm leading-5 text-gray-500">
                              {userDetail?.Industry || "NA"}
                            </p>
                          </div>
                        </div>
                        <div className="sm:col-span-3">
                          <div className="min-w-0 flex-auto">
                            <p className="text-sm font-semibold leading-6 text-gray-900">
                              Concentration
                            </p>
                            <p className="mt-1 truncate text-sm leading-5 text-gray-500">
                              {userDetail?.Concentration || "NA"}
                            </p>
                          </div>
                        </div>
                      </div>

                      {occupation !== "Product" && (
                        <>
                          <span className="text-gray-800 text-sm font-normal mt-5 flex items-center  gap-2 border border-gray-300 p-1">
                            Professional Experience 1
                          </span>
                          <div className="mt-5 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-12">
                            <div className="sm:col-span-4">
                              <div className="min-w-0 flex-auto">
                                <p className="text-sm font-semibold leading-6 text-gray-900">
                                  Company Name
                                </p>
                                <p className="mt-1 truncate text-sm leading-5 text-gray-500">
                                  {userDetail?.CompanyProfessionalExperience1 ||
                                    "NA"}
                                </p>
                              </div>
                            </div>
                            <div className="sm:col-span-4">
                              <div className="min-w-0 flex-auto">
                                <p className="text-sm font-semibold leading-6 text-gray-900">
                                  Position
                                </p>
                                <p className="mt-1 truncate text-sm leading-5 text-gray-500">
                                  {userDetail?.PositionProfessionalExperience1 ||
                                    "NA"}
                                </p>
                              </div>
                            </div>
                            <div className="sm:col-span-4">
                              <div className="min-w-0 flex-auto">
                                <p className="text-sm font-semibold leading-6 text-gray-900">
                                  Year
                                </p>
                                <p className="mt-1 truncate text-sm leading-5 text-gray-500">
                                  {userDetail?.YearProfessionalExperience1 ||
                                    "NA"}
                                </p>
                              </div>
                            </div>
                          </div>

                          <span className="text-gray-800 text-sm font-normal mt-5 flex items-center  gap-2 border border-gray-300 p-1">
                            Professional Experience 2
                          </span>
                          <div className="mt-5 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-12">
                            <div className="sm:col-span-4">
                              <div className="min-w-0 flex-auto">
                                <p className="text-sm font-semibold leading-6 text-gray-900">
                                  Company Name
                                </p>
                                <p className="mt-1 truncate text-sm leading-5 text-gray-500">
                                  {userDetail?.CompanyProfessionalExperience2 ||
                                    "NA"}
                                </p>
                              </div>
                            </div>
                            <div className="sm:col-span-4">
                              <div className="min-w-0 flex-auto">
                                <p className="text-sm font-semibold leading-6 text-gray-900">
                                  Position
                                </p>
                                <p className="mt-1 truncate text-sm leading-5 text-gray-500">
                                  {userDetail?.PositionProfessionalExperience2 ||
                                    "NA"}
                                </p>
                              </div>
                            </div>
                            <div className="sm:col-span-4">
                              <div className="min-w-0 flex-auto">
                                <p className="text-sm font-semibold leading-6 text-gray-900">
                                  Year
                                </p>
                                <p className="mt-1 truncate text-sm leading-5 text-gray-500">
                                  {userDetail?.YearProfessionalExperience2 ||
                                    "NA"}
                                </p>
                              </div>
                            </div>
                          </div>

                          <span className="text-gray-800 text-sm font-normal mt-5 flex items-center gap-2 border border-gray-300 p-1">
                            Professional Experience 3
                          </span>
                          <div className="mt-5 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-12">
                            <div className="sm:col-span-4">
                              <div className="min-w-0 flex-auto">
                                <p className="text-sm font-semibold leading-6 text-gray-900">
                                  Company Name
                                </p>
                                <p className="mt-1 truncate text-sm leading-5 text-gray-500">
                                  {userDetail?.CompanyProfessionalExperience3 ||
                                    "NA"}
                                </p>
                              </div>
                            </div>
                            <div className="sm:col-span-4">
                              <div className="min-w-0 flex-auto">
                                <p className="text-sm font-semibold leading-6 text-gray-900">
                                  Position
                                </p>
                                <p className="mt-1 truncate text-sm leading-5 text-gray-500">
                                  {userDetail?.PositionProfessionalExperience3 ||
                                    "NA"}
                                </p>
                              </div>
                            </div>
                            <div className="sm:col-span-4">
                              <div className="min-w-0 flex-auto">
                                <p className="text-sm font-semibold leading-6 text-gray-900">
                                  Year
                                </p>
                                <p className="mt-1 truncate text-sm leading-5 text-gray-500">
                                  {userDetail?.YearProfessionalExperience3 ||
                                    "NA"}
                                </p>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                    {occupation !== "Product" && (
                      <>
                        <div className="mt-5">
                          <h1 className="text-md font-semibold text-blue-400">
                            EDUCATIONAL INFO
                          </h1>
                          <span className="text-gray-800 text-sm font-normal mt-5 flex items-center gap-2 border border-gray-300 p-1">
                            Education 1
                          </span>
                          <div className="mt-5 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-12">
                            <div className="sm:col-span-3">
                              <div className="min-w-0 flex-auto">
                                <p className="text-sm font-semibold leading-6 text-gray-900">
                                  Education Degree
                                </p>
                                <p className="mt-1 truncate text-sm leading-5 text-gray-500">
                                  {userDetail?.EducationDegree1 || "NA"}
                                </p>
                              </div>
                            </div>
                            <div className="sm:col-span-3">
                              <div className="min-w-0 flex-auto">
                                <p className="text-sm font-semibold leading-6 text-gray-900">
                                  Institute or School
                                </p>
                                <p className="mt-1 truncate text-sm leading-5 text-gray-500">
                                  {userDetail?.EducationalInstitute1 || "NA"}
                                </p>
                              </div>
                            </div>
                            <div className="sm:col-span-3">
                              <div className="min-w-0 flex-auto">
                                <p className="text-sm font-semibold leading-6 text-gray-900">
                                  Title or Career
                                </p>
                                <p className="mt-1 truncate text-sm leading-5 text-gray-500">
                                  {userDetail?.EducationTitle1 || "NA"}
                                </p>
                              </div>
                            </div>
                            <div className="sm:col-span-3">
                              <div className="min-w-0 flex-auto">
                                <p className="text-sm font-semibold leading-6 text-gray-900">
                                  Finish Year
                                </p>
                                <p className="mt-1 truncate text-sm leading-5 text-gray-500">
                                  {userDetail?.EducationYear1 || "NA"}
                                </p>
                              </div>
                            </div>
                          </div>

                          <span className="text-gray-800 text-sm font-normal mt-5 flex items-center gap-2 border border-gray-300 p-1">
                            Education 2
                          </span>
                          <div className="mt-5 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-12">
                            <div className="sm:col-span-3">
                              <div className="min-w-0 flex-auto">
                                <p className="text-sm font-semibold leading-6 text-gray-900">
                                  Education Degree
                                </p>
                                <p className="mt-1 truncate text-sm leading-5 text-gray-500">
                                  {userDetail?.EducationDegree2 || "NA"}
                                </p>
                              </div>
                            </div>
                            <div className="sm:col-span-3">
                              <div className="min-w-0 flex-auto">
                                <p className="text-sm font-semibold leading-6 text-gray-900">
                                  Institute or School
                                </p>
                                <p className="mt-1 truncate text-sm leading-5 text-gray-500">
                                  {userDetail?.EducationalInstitute2 || "NA"}
                                </p>
                              </div>
                            </div>
                            <div className="sm:col-span-3">
                              <div className="min-w-0 flex-auto">
                                <p className="text-sm font-semibold leading-6 text-gray-900">
                                  Title or Career
                                </p>
                                <p className="mt-1 truncate text-sm leading-5 text-gray-500">
                                  {userDetail?.EducationTitle2 || "NA"}
                                </p>
                              </div>
                            </div>
                            <div className="sm:col-span-3">
                              <div className="min-w-0 flex-auto">
                                <p className="text-sm font-semibold leading-6 text-gray-900">
                                  Finish Year
                                </p>
                                <p className="mt-1 truncate text-sm leading-5 text-gray-500">
                                  {userDetail?.EducationYear2 || "NA"}
                                </p>
                              </div>
                            </div>
                          </div>

                          <span className="text-gray-800 text-sm font-normal mt-5 flex items-center gap-2 border border-gray-300 p-1">
                            Education 3
                          </span>
                          <div className="mt-5 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-12">
                            <div className="sm:col-span-3">
                              <div className="min-w-0 flex-auto">
                                <p className="text-sm font-semibold leading-6 text-gray-900">
                                  Education Degree
                                </p>
                                <p className="mt-1 truncate text-sm leading-5 text-gray-500">
                                  {userDetail?.EducationDegree3 || "NA"}
                                </p>
                              </div>
                            </div>
                            <div className="sm:col-span-3">
                              <div className="min-w-0 flex-auto">
                                <p className="text-sm font-semibold leading-6 text-gray-900">
                                  Institute or School
                                </p>
                                <p className="mt-1 truncate text-sm leading-5 text-gray-500">
                                  {userDetail?.EducationalInstitute3 || "NA"}
                                </p>
                              </div>
                            </div>
                            <div className="sm:col-span-3">
                              <div className="min-w-0 flex-auto">
                                <p className="text-sm font-semibold leading-6 text-gray-900">
                                  Title or Career
                                </p>
                                <p className="mt-1 truncate text-sm leading-5 text-gray-500">
                                  {userDetail?.EducationTitle3 || "NA"}
                                </p>
                              </div>
                            </div>
                            <div className="sm:col-span-3">
                              <div className="min-w-0 flex-auto">
                                <p className="text-sm font-semibold leading-6 text-gray-900">
                                  Finish Year
                                </p>
                                <p className="mt-1 truncate text-sm leading-5 text-gray-500">
                                  {userDetail?.EducationYear3 || "NA"}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mt-5">
                          <h1 className="text-md font-semibold text-gray-800">
                            SOFTWARE EXPERIENCE
                          </h1>
                          <div className="flex flex-wrap justify-center items-center w-full gap-4 mt-5">
                            {userDetail?.SoftwareLogo?.map((logo, index) => (
                              <img
                                key={index}
                                src={logo}
                                alt="software exp"
                                className="w-10 h-10 object-contain"
                              />
                            ))}
                          </div>
                        </div>
                      </>
                    )}
                    <div className="mt-5">
                      <h1 className="text-md font-semibold text-blue-400">
                        CONTACT INFO
                      </h1>
                      <div className="mt-5 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-12">
                        <div className="sm:col-span-3">
                          <div className="min-w-0 flex-auto">
                            <p className="text-sm font-semibold leading-6 text-gray-900">
                              Contact Email Address
                            </p>
                            <p className="mt-1 truncate text-sm leading-5 text-gray-500">
                              {userDetail?.ContactEmailAddress || "NA"}
                            </p>
                          </div>
                        </div>
                        <div className="sm:col-span-3">
                          <div className="min-w-0 flex-auto">
                            <p className="text-sm font-semibold leading-6 text-gray-900">
                              Contact Phone Number
                            </p>
                            <p className="mt-1 truncate text-sm leading-5 text-gray-500">
                              {userDetail?.ContactPhoneNumber || "NA"}
                            </p>
                          </div>
                        </div>
                        <div className="sm:col-span-3">
                          <div className="min-w-0 flex-auto">
                            <p className="text-sm font-semibold leading-6 text-gray-900">
                              Website Link
                            </p>
                            <p className="mt-1 truncate text-sm leading-5 text-blue-700 underline cursor-pointer">
                              {userDetail?.WebsiteLink || "NA"}
                            </p>
                          </div>
                        </div>
                        </div>
                      </div>
                      <div className="mt-5 pt-5 border-t border-gray-200">
                        <div className="flex flex-wrap justify-center items-center w-full gap-4 cursor-pointer">
                          {userDetail?.InstagramIconLink && (
                            <a
                              href={userDetail.InstagramIconLink}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <InstagramIcon className="w-10 h-10 text-gray-400 hover:text-gray-600 transition-colors" />
                            </a>
                          )}
                          {userDetail?.FacebookIconLink && (
                            <a
                              href={userDetail.FacebookIconLink}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <FacebookIcon className="w-10 h-10 text-gray-400 hover:text-gray-600 transition-colors" />
                            </a>
                          )}
                          {userDetail?.YoutubeIconLink && (
                            <a
                              href={userDetail.YoutubeIconLink}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <YouTubeIcon className="w-10 h-10 text-gray-400 hover:text-gray-600 transition-colors" />
                            </a>
                          )}
                          {userDetail?.IssueIconLink && (
                            <a
                              href={userDetail.IssueIconLink}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <InsertLinkIcon className="w-10 h-10 text-gray-400 hover:text-gray-600 transition-colors" />
                            </a>
                          )}
                          {userDetail?.XIconLink && (
                            <a
                              href={userDetail.XIconLink}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <AttachFileIcon className="w-10 h-10 text-gray-400 hover:text-gray-600 transition-colors" />
                            </a>
                          )}
                        </div>
                      </div>
                    <div className="mt-5">
                      <h1 className="text-md font-semibold text-blue-400 ">
                        OTHER INFO
                      </h1>
                      <div className="min-w-0 flex-auto">
                        <p className="text-sm font-semibold leading-6 text-gray-900">
                          Magazine Shipping Address
                        </p>
                        <p className="mt-1 truncate text-sm leading-5 text-gray-500">
                          {userDetail?.MagazineShippingAddress || "NA"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
